module.exports = __webpack_public_path__ + "img/question_box.613519f2.svg";